export default __webpack_public_path__ + "static/5-4903360c87493038e87edd09d6a5ed6c.jpeg";